<div id="column-main">
    <div id="column-general">
        <div id="rows">
            <div class="row">
                @for (title of rows().titles; track $index) {
                    <h2>{{title}}</h2>
                }
                <!-- <h2>{{rows().titleRight}}</h2> -->
            </div>
            <!-- @for (row of rows().text; track $index) {
                <div class="row border">
                    <p class="text">{{row.textLeft}}</p>
                    <p class="text">{{row.textRight}}</p>
                </div>
            } -->
                @for (row of rows().text; track $index) {
                    <div class="row border">
                        @for (text of row; track $index) {
                            <p class="text">{{text}}</p>
                        }
                    </div>
                }

        </div>

        <div id="rows-mobile">
            <div id="rows-mobile-general">
                @for (title of rows().titles; track $index; let i = $index) {
                    <div class="row-mobile">
                        <h2>{{title}}</h2>
            
                        <div class="rows-mobile-text">
                            @for (row of rows().text; track $index) {
                                <p class="text">{{row[i]}}</p>
                            }
                        </div>
                    </div>
                }

                <!-- <div class="row-mobile">
                    <h2>{{rows().titleRight}}</h2>
    
                    <div class="rows-mobile-text">
                        @for (row of rows().text; track $index) {
                            <p class="text">{{row.textRight}}</p>
                        }
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</div>